'use strict';

require('backbone.stickit');
const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const ProjectMemberSearchView = require('common/ui/view/project/member-search');
const StateEditView = require('communication/ui/view/task/state-edit');
const Template = require('communication/ui/template/task/setting.hbs');
const AssigneeEditView = require('communication/ui/view/task/assignee-edit');

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        stateEdit: '.state-edit',
        assignees: '.assignees',
        assigneeSearch: '.assignee-search',
        comment: '.task-comment-list',
        additional: '.additional',
        selector: '.selector',
    },
    ui: {
        selfAssign: '.assign-self'
    },
    events: {
        'click @ui.selfAssign': 'selfAssign'
    },
    modelEvents: {
        'change': 'updatable'
    },
    childViewEvents: {
        'change:state': 'updatable',
        'select:member': 'updatable',
        'remove:member': 'updatable',
        'update:key': 'updatable'
    },
    bindings: {
        '.name input': 'name'
    },

    templateContext: function() {
        return {
            hasCommentView: this.getOption('CommentView') ? true : false
        }
    },

    initialize: function() {
        const isEditing = this.getOption('isEditing');
        if(isEditing) {
            this.model = this.model.clone();
        }
        this._assignees = new Backbone.Collection();
        this.assign(this.model.getAssignees().map(a => a.getUser()));
    },

    onRender: function() {
        const isEditing = this.getOption('isEditing');
        if(isEditing) {
            this.showChildView('stateEdit', new StateEditView({
                model: this.model
            }));
        }
        this.showChildView('assignees', new AssigneeEditView({
            collection: this._assignees,
            context: this.getOption('context')
        }));

        this.showChildView('assigneeSearch', new ProjectMemberSearchView({
            project: this.getOption('context').getProject(),
            exclude: (member) => {
                return this._assignees.contains(member.getUser());
            }
        }));
        this.getChildView('assigneeSearch').on('select', member => {
            this.assign(member.getUser());
        });

        const CommentView = this.getOption('CommentView');
        if(CommentView) {
            this.showChildView('comment', new CommentView({
                model: this.getOption('comment'),
                inTaskComment: true,
                marked: this.getOption('marked'),
                context: this.getOption('context')
            }));
        }

        const AdditionalView = this.getOption('AdditionalView');
        if(AdditionalView) {
            this.showChildView('additional', new AdditionalView({
                relatedKeys: this.getOption('relatedKeys'),
                context: this.getOption('context'),
                isEditable: true
            }));
            this.showChildView('selector', this.getChildView('additional').getSelectorView());
        }

        this.stickit();
    },

    onChildviewRemove: function(child) {
        this._assignees.remove(child.model);
    },

    assign: function(user) {
        this._assignees.add(user);
    },

    selfAssign: function() {
        const context = this.getOption('context');
        const currentUser = context.getUser();
        this.assign(currentUser);
        this.updatable();
    },

    getJSON: function() {
        const relatedKeys = this.getChildView('additional').getRelatedKeys();

        const json = {
            name: this.model.getName(),
            state: this.model.getState(),
            assignees: this._assignees.map(a => a.id),
            relatedKeys: relatedKeys.map(key => key.toString())
        };
        return json;
    },

    updatable: function() {
        if(this.model.getName()) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    }
});



// WEBPACK FOOTER //
// ./communication/ui/view/task/setting.js